// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"menu_buttonWrapper__vN8NM","button":"menu_button__1sEP7","text":"menu_text__AmhH9"};